import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button, Upload, message } from "antd";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { RiDeleteBin6Line } from "react-icons/ri";

import uploadImg from "../../../src/assets/images/upload_icon.png";

export const UploadImage = ({
  setFileList,
  fileList,
  onRemoveImages,
  onDragEndImages,
  name = "",
  onChangeImages,
}) => {
  return (
    <div className="medicinesListWrapper">
      <div className="text-center medicineUploadFile">
        <div className="fs26fwb">Upload your images</div>
        <div className="fs18fw500 medicineFormats">
          Formats: PNG, JPG | Max file size: 2MB
        </div>
        <UploadField
          setFileList={setFileList}
          fileList={fileList}
          onChangeImages={onChangeImages}
          onRemoveImages={onRemoveImages}
          onDragEndImages={onDragEndImages}
          name={name}
        />
      </div>
    </div>
  );
};

const MAX_FILE_SIZE_MB = 2; // 2MB
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
const MAX_FILES = 10;

const UploadField = ({
  setFileList,
  fileList,
  onChangeImages,
  onRemoveImages,
  onDragEndImages,
  name,
}) => {
  const { control, setError, clearErrors } = useForm();

  const beforeUpload = (file) => {
    if (file.size > MAX_FILE_SIZE_BYTES) {
      setError("files", {
        type: "manual",
        message: `File size should be less than ${MAX_FILE_SIZE_MB}MB`,
      });
      message.error(`"${file.name}" exceeds the 2MB limit.`);
      return Upload.LIST_IGNORE; // Ignore the file
    }
    clearErrors("files");
    return true;
  };

  const onChange = ({ fileList: newFileList }) => {
    if (newFileList.length > MAX_FILES) {
      message.error(`You can upload up to ${MAX_FILES} files only.`);
      return;
    }
    onChangeImages(newFileList, name);
    // setFileList(newFileList);
  };

  const onRemove = (file) => {
    onRemoveImages(file, name);
    // setFileList((prevList) => prevList.filter((item) => item.uid !== file.uid));
  };

  const onDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    onDragEndImages(active, over, name);
    // setFileList((items) => {
    //   const oldIndex = items.findIndex((file) => file.uid === active.id);
    //   const newIndex = items.findIndex((file) => file.uid === over.id);
    //   return arrayMove(items, oldIndex, newIndex);
    // });
  };

  return (
    <div className="uploadImgWrapper">
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <DndContext
              collisionDetection={closestCenter}
              onDragEnd={onDragEnd}
            >
              <SortableContext
                items={fileList?.map((file) => file.uid)}
                strategy={verticalListSortingStrategy}
              >
                <div className="uploaded-images">
                  {fileList.map((file, index) => (
                    <SortableItem
                      key={file.uid}
                      file={file}
                      index={index}
                      onRemove={onRemove}
                    />
                  ))}
                </div>
              </SortableContext>
            </DndContext>
            <Upload
              {...field}
              // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
              // action={null}
              listType="picture-card"
              fileList={fileList}
              onChange={onChange}
              beforeUpload={beforeUpload}
              multiple={true}
              showUploadList={false} // Hide Ant Design default UI
              customRequest={"null"}
            >
              {fileList.length < MAX_FILES && (
                <div className="medicineUploadImgWrapper">
                  <img
                    src={uploadImg}
                    className="medicineUploadImg"
                    alt="Upload"
                  />
                  <div className="fs21fw500 medicineImg">
                    Drag & Drop your images here
                  </div>
                  <div>
                    <Button className="medicineBrowseBtn fs18fwb">
                      Click to Browse
                    </Button>
                  </div>
                </div>
              )}
            </Upload>
            {/* Drag & Drop Image List */}
            {error && <p className="error-message">{error.message}</p>}
          </>
        )}
      />
    </div>
  );
};

const getsrcValue = (file) => {
  if (typeof file?.url === "string" && file?.url?.length)
    return process.env.REACT_APP_API_URL + "medicines/" + file?.url;
  return typeof file === "object"
    ? file.url || URL.createObjectURL(file.originFileObj)
    : " ";
};

const SortableItem = ({ file, index, onRemove }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: file.uid });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    position: "relative",
    cursor: "grab",
  };

  return (
    <div ref={setNodeRef} className="orderMedicineCoverImg" style={style}>
      <div
        className="custom-upload-item "
        key={index}
        {...attributes}
        {...listeners}
      >
        {index === 0 && <div className="cover-label fs14fwb">Cover</div>}
        <img
          src={getsrcValue(file)}
          // src={file.url || URL.createObjectURL(file.originFileObj)}
          alt="uploaded"
          // style={{ width: 100, height: 100, objectFit: "cover" }}
        />
      </div>
      <div
        className="deleteOption position-absolute"
        onClick={() => onRemove(file)}
      >
        <RiDeleteBin6Line color="#fff" size={17} cursor="pointer">
          {" "}
        </RiDeleteBin6Line>
      </div>
    </div>
  );
};
